import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import Icon from '@/src/app/components/Icon/Icon';
import { IconName } from '@/src/app/components/Icon/types';
function OffcanvasToggleButton(t0) {
  const $ = _c(12);
  let onToggle;
  let open;
  let props;
  if ($[0] !== t0) {
    ({
      onToggle,
      open,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = onToggle;
    $[2] = open;
    $[3] = props;
  } else {
    onToggle = $[1];
    open = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== open) {
    t1 = classNames("offcanvas-toggle bg-black inline-block h-full px-8 pt-2", {
      "is-active": open
    });
    $[4] = open;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="offcanvas-toggle__icon " aria-hidden="true"><span className="offcanvas-toggle__line" /><span className="offcanvas-toggle__line" /><span className="offcanvas-toggle__line" /><Icon name={IconName.CHEVRON_LEFT} className="offcanvas-toggle__chevron" /></span>;
    t3 = <span className="offcanvas-toggle__text uppercase text-xs font-bold">Menu</span>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  let t4;
  if ($[8] !== onToggle || $[9] !== props || $[10] !== t1) {
    t4 = <button className={t1} type="button" data-testid="offcanvas-toggle-button" onClick={onToggle} {...props}>{t2}{t3}</button>;
    $[8] = onToggle;
    $[9] = props;
    $[10] = t1;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
export default OffcanvasToggleButton;